module.exports = __webpack_public_path__ + "img/TopMain.2936cbc6.jpg";